<div class="d-flex flex-column align-items-center justify-content-center text-center py-12 px-6">
    <div class="rounded-circle d-flex align-items-center justify-content-center mb-5" style="width: 88px; height: 88px; border: 2px dashed #CBD5E1;">
        <!-- <i class="bi bi-grid fs-2x text-gray-400"></i> -->
        <i class="bi bi-folder-x fs-2x text-dark"></i>
    </div>
    <h4 class="fw-semibold text-gray-700 mb-2">{{ message }}</h4>
    <p class="text-muted mb-0 fs-6" *ngIf="hint">{{ hint }}</p>
</div>

